import { useState, useRef, useEffect } from "react";

import Header from "../components/Header";
import Plans from "../components/Plans";
import WhatWeDo from "../components/WhatWeDo";
import './Index.css';

import Button from '@mui/material/Button';
import HowItWorks from "../components/HowItWorks";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import TextField from '@mui/material/TextField';
import { ReactTyped } from "react-typed";

import { motion } from "framer-motion";
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import PlaceIcon from '@mui/icons-material/Place';
// import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";
import SimulacaoImpostos from "../components/SimulacaoImpostos";
import { Divider } from "@mui/material";
import Box from '@mui/material/Box';
// import { Divider } from "@mui/material";

function Home() {
    const navigate = useNavigate();

    const [cidades, setCidades] = useState([]);
    const [cidadesFiltered, setCidadesFiltered] = useState([]);

    // const parseCSVLine = (line) => {
    //     // Vai separar por vírgula apenas fora de aspas
    //     const regex = /(".*?"|[^",\s]+)(?=\s*,|\s*$)/g;
    //     return line.match(regex).map(field => field.replace(/^"|"$/g, ''));
    // };


    useEffect(() => {
        window.scrollTo(0, 0);

        let pathCsv = "/assets/csvCidades/Cidades homologadas - 14-11-2025.csv";

        const reader = new FileReader();
        fetch(pathCsv)
            .then(response => response.blob())
            .then(blob => {
                reader.readAsText(blob);
            });
        reader.onload = () => {
            const csvData = reader.result;
            const lines = csvData.split('\n').slice(1); // Ignora o cabeçalho
            for (let line of lines) {
                let [status, cidade, uf, layoutIntegracao, padrao, documentacaoDoPadrao, codigoIbge, dadosObrigatoriosDasNotasTomadas, notasTomadas, login, senha, multiplosServicos, certificado] = line.split(',').map(field => field.replace(/^"|"$/g, '').trim());
                setCidades(prevCidades => [...prevCidades, { status, cidade, uf, layoutIntegracao, padrao, documentacaoDoPadrao, codigoIbge, dadosObrigatoriosDasNotasTomadas, notasTomadas, login, senha, multiplosServicos, certificado }]);
            }
        }
    }, [])
    const cards = [
        { value: "Médicos", img: "/assets/nichosMedico.jpeg", desc: "Contabilidade especializada para médicos de todas as especialidades." },
        { value: "Odontologistas", img: "/assets/nichosDentista.jpeg", desc: "Foco na rotina fiscal e tributária dos profissionais de odontologia." },
        { value: "Fisioterapeutas", img: "/assets/nichosFisioterapia.jpeg", desc: "Soluções sob medida para profissionais que atuam com saúde mental e bem-estar." },
        { value: "Clínicas e Centros de Saúde", img: "/assets/nichosClinicas.jpeg", desc: "Gestão contábil personalizada para quem trabalha com reabilitação, pilates e terapias integrativas." },
        { value: "Profissionais Autônomos da Saúde", img: "/assets/nichosAutonomos.jpeg", desc: "Estrutura contábil completa para empresas da área da saúde que atuam com múltiplos profissionais e serviços." },
        { value: "Psicólogos e Terapeutas", img: "/assets/nichosPsicologo.jpeg", desc: "Para quem atende de forma independente ou domiciliar e precisa de organização fiscal simples e eficaz." },
        // { value: "Radiologistas", img: "/assets/raiox.png", desc: "Exames de imagem realizados com precisão para auxiliar no diagnóstico e acompanhamento médico." },
        { value: "Profissionais de Pediatria", img: "/assets/pediatra.jpg", desc: "Cuidado dedicado à saúde infantil, com atenção especial ao desenvolvimento físico e emocional das crianças." },
        { value: "Personal Trainer", img: "/assets/personal.jpg", desc: "Acompanhamento individualizado para melhorar sua saúde, desempenho físico e qualidade de vida com treinos personalizados." },
    ];

    const plansRef = useRef(null);

    const cardVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: i => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.1, duration: 0.4 }
        }),
    };

    const scrollToPlans = () => {
        plansRef.current?.scrollIntoView({ behavior: 'smooth' });
    };


    const handleFilterCity = (input) => {
        if (!input) {
            setCidadesFiltered([]);
            return;
        }
        const normalizeText = (text) =>
            text
                .normalize('NFD') // separa caracteres + acentos
                .replace(/[\u0300-\u036f]/g, '') // remove acentos
                .replace(/\s+/g, ' ') // normaliza espaços
                .trim()
                .toLowerCase();

        const filtered = cidades
            .filter(cidade => {
                const cidadeNormalized = normalizeText(cidade.cidade);
                const inputNormalized = normalizeText(input);
                return cidadeNormalized.includes(inputNormalized);
            })
            .slice(0, 2);


        if (filtered.length === 0) {
            setCidadesFiltered(false);
            return;
        }
        setCidadesFiltered(filtered);
    }

    return (
        <>
            <Header />
            <div
                style={{
                    width: "100%",
                    height: "100vh",
                    opacity: 1,
                    backgroundImage: 'url("/assets/banner.jpg")',
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0 0 20px",
                }}
            >
                {/* Overlay escuro para contraste */}
                <motion.div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        zIndex: 1,
                    }}
                ></motion.div>

                {/* Conteúdo sobre a imagem */}
                <motion.div
                    style={{
                        position: "relative",
                        zIndex: 2,
                        maxWidth: "800px",
                        textAlign: "center",
                        color: "#fff",
                    }}
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <motion.h1
                        style={{ fontSize: "2.5rem", fontWeight: "bold", marginBottom: "20px", marginTop: "80px" }}
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.6 }}
                    >
                        A contabilidade para quem cuida da saúde.
                    </motion.h1>


                    <motion.p
                        style={{ fontSize: "1.2rem", lineHeight: "1.6", marginBottom: "40px" }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.6, duration: 0.6 }}
                    >
                        Se você é médico, dentista, psicólogo, fisioterapeuta ou profissional da área da saúde, conheça os planos da Clarea feitos sob medida para sua rotina!
                    </motion.p>

                    <motion.div
                        style={{
                            display: "flex",
                            gap: "20px",
                            justifyContent: "center",
                            flexWrap: "wrap",
                        }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.9, duration: 0.6 }}
                    >
                        <Button
                            variant="contained"
                            sx={{
                                padding: "14px 28px",
                                fontSize: "1rem",
                                backgroundColor: "#ffc845",
                                color: "#0b243d",
                                fontWeight: 600,
                                borderRadius: "10px",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                transition: "0.3s ease",
                                '&:hover': {
                                    backgroundColor: "#e6b53e",
                                    transform: "scale(1.05)",
                                },
                            }}
                            onClick={() => navigate("../Solucoes")}
                        >
                            Troque de contador
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                padding: "14px 28px",
                                fontSize: "1rem",
                                backgroundColor: "#ffc845",
                                color: "#0b243d",
                                fontWeight: 600,
                                borderRadius: "10px",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                transition: "0.3s ease",
                                '&:hover': {
                                    backgroundColor: "#e6b53e",
                                    transform: "scale(1.05)",
                                },
                            }}
                            onClick={() => navigate("../Planos")}
                        >
                            Contrate
                        </Button>
                    </motion.div>
                </motion.div>
            </div>

            <div className="hero-container sectionTwo">
                <div className="hero-wrapper">
                    <div className="hero-content">

                        {/* Imagem com fade + scale */}
                        <motion.div
                            className="hero-image"
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.8 }}
                        >
                            <img src="/assets/contabilidade-para-medicos.jpg" alt="Profissional da saúde" style={{
                                width: "100%",
                                height: "auto",
                                borderRadius: "20px", // cantos arredondados suaves
                                objectFit: "cover",   // mantém proporção e evita distorção
                                boxShadow: "0 0px 14px #ffc845", // sombra leve para destacar
                            }} />
                        </motion.div>

                        {/* Texto com entrada da direita */}
                        <motion.div
                            className="hero-text"
                            initial={{ opacity: 0, x: 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                        >
                            <motion.p
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.2, duration: 0.5 }}
                                style={{ color: "#ffc845", fontWeight: 600 }}
                            >
                                A Clarea
                            </motion.p>

                            <motion.h2
                                initial={{ opacity: 0, y: -20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.4, duration: 0.6 }}
                                style={{ height: "fit-content", minHeight: "170px", fontSize: "2.2rem", fontWeight: "bold", marginBottom: "20px" }}
                            >
                                Somos uma contabilidade simples{" "}
                                <ReactTyped
                                    strings={[
                                        "para profissionais da saúde.",
                                        "para quem não tem tempo a perder.",
                                        "que entende a rotina da saúde."
                                    ]}
                                    typeSpeed={120}
                                    backSpeed={30}
                                    loop
                                />

                            </motion.h2>

                            <motion.p
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.6, duration: 0.6 }}
                            >
                                Somos uma contabilidade e assessoria tributária pensada para quem dedica a vida ao cuidado com as pessoas. Conhecemos as <b>exigências e particularidades</b> do setor da saúde e oferecemos a <b>tranquilidade</b> de estar em dia com as obrigações fiscais de forma <b>prática e descomplicada</b>.
                            </motion.p>

                            <motion.div
                                className="hero-buttons"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.8, duration: 0.6 }}
                            >
                                <Button variant="contained" sx={{
                                    padding: "14px 28px",
                                    fontSize: "1rem",
                                    backgroundColor: "#ffc845",
                                    color: "#0b243d",
                                    fontWeight: 600,
                                    borderRadius: "10px",
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    transition: "0.3s ease",
                                    '&:hover': {
                                        backgroundColor: "#e6b53e",
                                        transform: "scale(1.05)",
                                    }
                                }} onClick={() => navigate("../SobreNos")}>
                                    conheça a Clarea
                                </Button>
                            </motion.div>
                        </motion.div>
                    </div>
                </div>
            </div>
            <div style={{ width: "100%", display: "flex", justifyContent: "center", background: "linear-gradient(35deg, #ffc845 0%, white 100%)", padding: "40px 0" }}>
                <div style={{ width: "80%", maxWidth: "900px" }}>

                    <h1
                        style={{
                            fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
                            margin: "30px 0",
                            textAlign: "center",
                            color: "black",
                            lineHeight: 1.3,
                        }}
                    >
                        Descubra como podemos transformar sua relação com a contabilidade
                    </h1>

                    {/* Linha Verde */}
                    <div
                        style={{
                            width: "100%",
                            height: "2px",
                            backgroundColor: "#ffc845",
                            margin: "30px 0",
                        }}
                    />

                    <Box
                        sx={{
                            position: "relative",
                            paddingBottom: "56.25%", // Proporção 16:9
                            height: 0,
                            overflow: "hidden",
                            borderRadius: 2,
                            boxShadow: "0px 0px 50px #ffc845"
                        }}
                    >
                        <video
                            src="/assets/VideoApresentacao.mp4"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "8px",
                            }}
                            controls
                        />
                    </Box>

                    {/* Linha Verde */}
                    <div
                        style={{
                            width: "100%",
                            height: "2px",
                            backgroundColor: "#ffc845",
                            margin: "30px 0",
                        }}
                    />
                </div>
            </div>
            <WhatWeDo scrollToPlans={scrollToPlans} />
            <SimulacaoImpostos />
            <div className="hero-container" style={{ backgroundColor: "#f9f2e4" }}>
                <div className="hero-wrapper">
                    <div className="hero-content" style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap' }}>
                        <motion.div
                            className="hero-text"
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                            style={{ flex: '1 1 300px' }}
                        >
                            <p style={{ color: "#0b243d", fontWeight: 600 }}>PLANOS</p>
                            <h1>Escolha o plano ideal para seu consultório ou clínica.</h1>
                            <p>
                                Sabemos que cada especialidade da área da saúde tem suas próprias necessidades. Por isso, desenvolvemos planos personalizados para médicos, dentistas, psicólogos, fisioterapeutas e outros profissionais da saúde.
                            </p>
                        </motion.div>

                        <div
                            className="hero-image"
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.8, delay: 0.3 }}
                            style={{ flex: '1 1 300px', display: 'flex', justifyContent: 'center' }}
                        >
                            <img src="/assets/planos.jpeg" alt="Profissional da saúde" style={{
                                width: "100%",
                                margin: "0 auto",
                                height: "auto",
                                borderRadius: "20px", // cantos arredondados suaves
                                objectFit: "cover",   // mantém proporção e evita distorção
                                boxShadow: "0 0px 14px #ffc845", // sombra leve para destacar
                            }} />
                        </div>
                    </div>
                </div>
            </div>
            <section
                style={{
                    width: "100%",
                    minHeight: "500px",
                    background: "linear-gradient(135deg, #0b243d 0%, #1b3a5d 100%)",
                    padding: "60px 20px",
                    boxSizing: "border-box",
                    color: "#ffffff",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        maxWidth: "800px",
                        textAlign: "center",
                        marginBottom: "30px",
                        padding: "0 10px",
                    }}
                >
                    <h1
                        style={{
                            fontSize: "clamp(1.2rem, 4vw, 2.5rem)",
                            margin: 0,
                            lineHeight: 1.3,
                            color: "#ffffff",
                        }}
                    >
                        Descubra se sua cidade também é compatível.
                    </h1>
                    <p
                        style={{
                            marginTop: "10px",
                            color: "#ffc845",
                            fontSize: "clamp(0.9rem, 2vw, 1.1rem)",
                            lineHeight: 1.5,
                        }}
                    >
                        O emissor Clarea Fácil está homologado em mais de 2.000 cidades e compatível com centenas de padrões de Nota Fiscal de Serviço (NFS-e) em todo o Brasil. <a href="/assets/csvCidades/Cidades_homologadas.xlsx" download style={{ color: "#ffc845", textDecoration: "underline" }}>baixe aqui</a>
                    </p>
                </div>

                <div
                    style={{
                        width: "100%",
                        maxWidth: "600px",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        gap: "20px",
                        margin: "0 auto",
                        padding: "0 10px",
                    }}
                >
                    <TextField
                        placeholder="Digite sua cidade"
                        fullWidth
                        variant="outlined"
                        sx={{
                            width: { xs: "100%", sm: "80%", md: "60%" },
                            backgroundColor: "#ffffff",
                            borderRadius: "8px",
                            "& .MuiInputBase-input": {
                                color: "#0b243d",
                            },
                            "& .MuiInputLabel-root": {
                                color: "#0b243d",
                            },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    borderColor: "#ffffff",
                                },
                                "&:hover fieldset": {
                                    borderColor: "#ffc845",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#ffc845",
                                },
                            },
                        }}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <PlaceIcon sx={{ color: "#0b243d", mr: 1 }} position="start" />
                                ),
                            },
                        }}
                        onChange={e => handleFilterCity(e.target.value)}
                    />
                </div>
                <div
                    style={{
                        width: "100%",
                        maxWidth: "600px",
                        marginTop: "20px",
                        padding: "10px",
                    }}
                >
                    {
                        !cidadesFiltered ? (
                            <div style={{ textAlign: "center", marginTop: "20px" }}>
                                <p>Cidade não encontrada.</p>
                            </div>
                        ) : (
                            cidadesFiltered.map((cidade, index) => {
                                const rowStyle = {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    flexWrap: "wrap",
                                    gap: "12px",
                                    marginTop: "10px",
                                };

                                const infoBoxStyle = {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "4px",
                                    minWidth: "120px",
                                };

                                const chipBoxStyle = {
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "8px",
                                    marginTop: "12px",
                                };

                                return (
                                    <div
                                        key={index}
                                        style={{
                                            backgroundColor: "#1b3a5d",
                                            padding: "15px",
                                            borderRadius: "10px",
                                            color: "#fff",
                                            marginBottom: "20px",
                                            boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
                                        }}
                                    >
                                        {/* Linha 1: Cidade e UF */}
                                        <div style={rowStyle}>
                                            <div style={infoBoxStyle}>
                                                <span style={{ fontWeight: "600" }}>Cidade:</span>
                                                <span>{cidade.cidade}</span>
                                            </div>
                                            <div style={infoBoxStyle}>
                                                <span style={{ fontWeight: "600" }}>UF:</span>
                                                <span>{cidade.uf}</span>
                                            </div>
                                        </div>

                                        {/* Linha 2: Layout, Padrão e Código IBGE */}
                                        <div style={rowStyle}>
                                            <div style={infoBoxStyle}>
                                                <span style={{ fontWeight: "600" }}>Layout de integração:</span>
                                                <span>{cidade.layoutIntegracao}</span>
                                            </div>
                                            <div style={infoBoxStyle}>
                                                <span style={{ fontWeight: "600" }}>Padrão:</span>
                                                <span>{cidade.padrao}</span>
                                            </div>
                                            <div style={infoBoxStyle}>
                                                <span style={{ fontWeight: "600" }}>Código IBGE:</span>
                                                <span>{cidade.codigoIbge}</span>
                                            </div>
                                        </div>

                                        {/* Linha 3: Dados obrigatórios das notas tomadas */}
                                        {/* <div style={rowStyle}>
                                    <div style={{ ...infoBoxStyle, flex: "1 1 100%" }}>
                                        <span style={{ fontWeight: "600" }}>Dados obrigatórios das notas tomadas:</span>
                                        <span>{cidade.dadosObrigatoriosDasNotasTomadas}</span>
                                    </div>
                                </div> */}

                                        <Divider style={{ margin: "12px 0", borderColor: "#ffc845" }} />

                                        {/* Linha 4: Chips */}
                                        <div style={chipBoxStyle}>
                                            <Chip
                                                icon={
                                                    cidade.status === "Operante" ? (
                                                        <CheckIcon color="success" />
                                                    ) : (
                                                        <CloseIcon color="error" />
                                                    )
                                                }
                                                label={cidade.status === "Operante" ? "Cidade compatível com emissor Clarea Fácil" : "Cidade não compatível com emissor Clarea Fácil"}
                                                variant="outlined"
                                                sx={{ color: "#fff", borderColor: "#ffc845" }}
                                            />
                                        </div>
                                    </div>
                                );
                            })
                        )}
                </div>

            </section>


            <div ref={plansRef}>
                <Plans title="Escolha seu Plano" />
            </div>

            <section style={{ width: "100%", minHeight: "500px", backgroundColor: "#0b243d", padding: "20px", boxSizing: "border-box", color: "#fff" }}>
                <div style={{ width: "100%", textAlign: "center", marginBottom: "30px" }}>
                    <p style={{ margin: 0, color: "#ffc845" }}>NICHOS</p>
                    <h1 style={{ fontSize: "clamp(1.2rem, 4vw, 2.5rem)", margin: 0 }}>Contabilidade pensada para você</h1>
                </div>

                <div style={{ width: "90%", display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "30px", margin: "0 auto" }}>
                    <div style={{ flex: "1 1 300px", maxWidth: "700px", display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "20px" }}>
                        {cards.map((obj, index) => (
                            <div
                                key={index}
                                custom={index}
                                variants={cardVariants}
                                initial="hidden"
                                animate="visible"
                                style={{
                                    width: "200px",
                                    height: "150px",
                                    border: "1px solid #ffc845",
                                    borderRadius: "15px",
                                    padding: "10px 20px",
                                    textAlign: "center",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#f9f2e4",
                                    cursor: "pointer",
                                    color: "#0b243d"
                                }}
                            >
                                <div>
                                    <img src={obj.img} alt={obj.value} style={{ maxWidth: "130px", borderRadius: "8px" }} />
                                    <p style={{ lineHeight: "1", fontSize: "0.9rem" }}>{obj.value}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* <div style={{
                        flex: "1 1 300px",
                        maxWidth: "400px",
                        color: "#f9f2e4",
                        padding: "30px",
                        boxSizing: "border-box",
                        borderRadius: "12px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        backgroundColor: "rgba(255,255,255,0.05)"
                    }}>
                        <AnimatePresence mode="wait">
                            {(nichoTitle || nichoDesc) ? (
                                <motion.div
                                    key="content"
                                    variants={textVariants}
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    style={{ textAlign: "left" }}
                                >
                                    <h2 style={{ fontSize: "clamp(1.2rem, 2vw, 1.8rem)", marginBottom: "15px", color: "#ffc845" }}>{nichoTitle || "Conheça mais"}</h2>
                                    <p style={{
                                        fontSize: "clamp(0.9rem, 1.2vw, 1.1rem)",
                                        lineHeight: "1.6",
                                        whiteSpace: "pre-wrap",
                                        opacity: 0.9,
                                    }}>{nichoDesc || "Passe o mouse sobre um nicho para ver os benefícios e diferenciais da contabilidade especializada para ele."}</p>
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="default"
                                    variants={textVariants}
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    style={{ textAlign: "left" }}
                                >
                                    <h2 style={{ fontSize: "clamp(1.2rem, 2vw, 1.8rem)", marginBottom: "15px", color: "#ffc845" }}>Conheça mais</h2>
                                    <p style={{
                                        fontSize: "clamp(0.9rem, 1.2vw, 1.1rem)",
                                        lineHeight: "1.6",
                                        whiteSpace: "pre-wrap",
                                        opacity: 0.9,
                                    }}>
                                        Passe o mouse sobre um nicho para ver os benefícios e diferenciais da contabilidade especializada para ele.
                                    </p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div> */}
                </div>
            </section>

            <HowItWorks />
            <Footer />
        </>
    );
}

export default Home;
